import { AxiosInstance, AxiosRequestConfig } from "axios";
import { IFilteredOptions } from "../filteredApi/FilteredApiModel";
import { FilteredProjectApiModel } from "../filteredApi/FilteredProjectApiModel";
import http from "../Http";

export class ProjectTeamUserPermissionsApi extends FilteredProjectApiModel<FP.Entities.IUserPermission> {
  controller: string = "project-team-user-authorisation";
  urlWithOrg: string;
  /**
   *
   */
  constructor(http: AxiosInstance) {
    super(http, "project-team-user-authorisation");
  }

  getUsersInProject = async (
    organisationId: number,
    projectId: number,
    filterOptions: Partial<IFilteredOptions>,
    config?: AxiosRequestConfig
  ) => {
    let query = this.getRequestQuery(filterOptions);
    const url = `${this.url}/${organisationId}/projects/${projectId}/${this.controller}`;
    let res = await this.http.get(url + query, config);
    return res.data;
  };

  getAllUsersSimple = async (organisationId: number, projectId: number, config?: AxiosRequestConfig) => {
    const url = `${this.url}/${organisationId}/projects/${projectId}/${this.controller}/project-team-users-simple`;
    let res = await this.http.get(url, config);
    return res.data;
  };
}

const instance = new ProjectTeamUserPermissionsApi(http);
export default instance;
